import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { logger } from '@/lib/logger'

interface ProtectedRouteProps {
  children: React.ReactNode
}

/**
 * Protected Route Component
 *
 * Redirects to /login if user is not authenticated
 * Shows loading spinner while checking auth status
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, loading } = useAuth()

  logger.debug('ProtectedRoute check:', { isAuthenticated, loading })

  if (loading) {
    logger.debug('ProtectedRoute: Still loading...')
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    )
  }

  if (!isAuthenticated) {
    logger.debug('ProtectedRoute: Not authenticated, redirecting to /login')
    return <Navigate to="/login" replace />
  }

  logger.debug('ProtectedRoute: Authenticated, rendering children')
  return <>{children}</>
}
